import { Button, ButtonGroup } from "@blueprintjs/core";
import { DatePicker } from "@blueprintjs/datetime";
import { Popover2 } from "@blueprintjs/popover2";
import { addWeeks, endOfWeek, format, startOfWeek } from "date-fns";
import fr from "date-fns/locale/fr";
import * as React from "react";

export interface IWeekPickerProps {
  selected: Date;
  onSelect: (day: Date) => void;
}

export const WeekPicker: React.FunctionComponent<IWeekPickerProps> = ({ onSelect, selected }) => {
  const [datePickerOpen, setDatePickerOpen] = React.useState(false);

  const next = React.useCallback(() => {
    let nextWeek = addWeeks(selected, 1);
    onSelect(nextWeek);
  }, [onSelect, selected]);

  const previous = React.useCallback(() => {
    let previousWeek = addWeeks(selected, -1);
    onSelect(previousWeek);
  }, [onSelect, selected]);

  const selectedWeekDisplay = React.useMemo(
    () =>
      `${format(startOfWeek(selected, { locale: fr }), "EEEE d MMMM yyyy", {
        locale: fr
      })} - ${format(endOfWeek(selected, { locale: fr }), "EEEE d MMMM yyyy", {
        locale: fr
      })}`,
    [selected]
  );

  return (
    <ButtonGroup>
      <Button icon="chevron-left" minimal onClick={previous} />
      <Popover2
        position="bottom"
        isOpen={datePickerOpen}
        onClose={() => setDatePickerOpen(false)}
        content={
          <DatePicker
            onChange={(val, isUserChange) => {
              if (isUserChange) {
                onSelect(val);
                setDatePickerOpen(false);
              }
            }}
            highlightCurrentDay
          />
        }
      >
        <Button
          text={selectedWeekDisplay}
          rightIcon="caret-down"
          style={{ flex: 1 }}
          minimal
          onClick={() => setDatePickerOpen(true)}
        />
      </Popover2>
      <Button icon="chevron-right" minimal onClick={next} />
    </ButtonGroup>
  );
};

export default WeekPicker;
